angular.module(NgAppName).directive('crResultsTablePhoto', ['PubSub', 'ImageService', function(PubSub, ImageService) {
	return {
		restrict: 'A',
		link: function(scope, element, attrs){
			scope.firstImage = null;

			scope.setImage = function() {
				if (scope.images && scope.images.length > 0) {
					// var imageUrls = scope.images[0];
					var firstImage = scope.images[0];
					if (firstImage) {
						scope.firstImage = ImageService.getSmartImage(attrs.width, attrs.height, firstImage, attrs.mode, attrs.format); 
					}
					// if (imageUrls.length === 1) {
					// 	scope.firstImage = ImageService.getSmartImage(attrs.width, attrs.height, imageUrls[0], attrs.mode);
					// } else if (imageUrls.length > 1) {
					// 	scope.firstImage = ImageService.getSmartImage(attrs.width, attrs.height, imageUrls[1], attrs.mode); // imageUrls[Math.floor(imageUrls.length / 2)];
					// }
				}
 
				// else if (attrs.firstImage){
				// 	scope.firstImage = ImageService.getSmartImage(attrs.width, attrs.height, attrs.firstImage, attrs.mode);
				// } else if (scope.imageFull && scope.imageFull.indexOf('missing') === -1) {
				// 	scope.firstImage = ImageService.getSmartImage(attrs.width, attrs.height, scope.imageFull, attrs.mode);
				// }
			};

			scope.setImage();

			scope.$watch('$ctrl.images', function(images) {
				if (images) {
					scope.images = images;
					scope.setImage();
				}
			});
		}
	};
}]);
